import { render, staticRenderFns } from "./CompanySettingsModal.vue?vue&type=template&id=bfa9d716"
import script from "./CompanySettingsModal.vue?vue&type=script&lang=js"
export * from "./CompanySettingsModal.vue?vue&type=script&lang=js"
import style0 from "./CompanySettingsModal.vue?vue&type=style&index=0&id=bfa9d716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports